export const es_co = {
  validation_error: 'Este campo es obligatorio.',
  all: 'Toda',
  filter_result_text: 'MOSTRANDO',
  filter_msg_title: 'No se han encontrado resultados.',
  filter_msg: 'No pudimos encontrar lo que buscas. Intenta buscar de nuevo.',
};
